import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import UIUtils from 'utils/UI';
import ApplePay from 'services/ApplePay';
import OrderUtils from 'utils/Order';
import { PAYMENT_LOGO_SIZE } from 'constants/Checkout';
import Radio from 'components/Inputs/Radio/Radio';
import PaymentDetails from 'components/FrictionlessCheckout/Payment/PaymentDetails';
import PaymentLogo from 'components/FrictionlessCheckout/Payment/PaymentLogo';
import { Grid, Divider } from 'components/ui';

const { isSMUI } = UIUtils;

const RADIO_NAME = 'payWithApplePay';

const Apple = props => {
    const [isApplePayEnabled, setIsApplePayEnabled] = useState(false);

    useEffect(() => {
        if (props.orderDetails) {
            ApplePay.getApplePaymentType(props.orderDetails).then(payType => {
                const isEnabled = payType !== ApplePay.TYPES.HIDDEN;
                setIsApplePayEnabled(isEnabled);
            });
        }
    }, [props.orderDetails]);

    const displayPayment = () => {
        const { payWithApplePay } = props.localization;

        return (
            <Grid
                columns='auto 1fr'
                gap={4}
                alignItems='center'
                lineHeight='tight'
            >
                <PaymentLogo
                    {...PAYMENT_LOGO_SIZE}
                    style={
                        isSMUI()
                            ? {
                                alignSelf: 'flex-start'
                            }
                            : null
                    }
                    paymentGroupType={OrderUtils.PAYMENT_GROUP_TYPE.APPLEPAY}
                />
                <b>{payWithApplePay}</b>
            </Grid>
        );
    };

    const {
        isPayWithApplePay, hasAutoReplenishItem, isBopis, isSdd, handlePayWithApplePayClick, isApplePay
    } = props;

    if (isApplePay) {
        return displayPayment();
    }

    return isApplePayEnabled ? (
        <div>
            <Radio
                paddingY={4}
                dotOffset={0}
                alignItems='center'
                name={RADIO_NAME}
                checked={isPayWithApplePay}
                disabled={isSMUI() && hasAutoReplenishItem}
                onClick={handlePayWithApplePayClick}
            >
                <PaymentDetails
                    isBopis={isBopis}
                    isSddOrder={isSdd}
                    isApplePay={true}
                    hasAutoReplenishItemInBasket={hasAutoReplenishItem}
                />
            </Radio>
            <Divider />
        </div>
    ) : null;
};

export default wrapFunctionalComponent(Apple, 'Apple');
